/**
 * @author Красильников Даниил <dkrasilnikov@gmail.com>
 * @link https://t.me/krasilneg
 * 
 * @author Колесник Данил <90.kalias.3@gmail.com>
 * @link https://t.me/kalias_90
 */

import { createContext } from 'react';
import IntersectionListener from './IntersectionListener.class';

const IntersectionContext = createContext<IntersectionListener | null>(null);

export default IntersectionContext;
